// Libraries
import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

// Styles
import './modal.scss';

const customStyles = {
    content: {
        background: '#fff',
    },
};
let portalRoot = document.getElementById('modal-root');
if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.setAttribute('id', 'modal-root');
    document.body.appendChild(portalRoot);
}
ReactModal.setAppElement('#modal-root');

const Modal = props => {
    const {
        children,
        setOverlayRef,
        setContentRef,
        modalId,
        contentLabel,
        ariaDescription,
        ariaLabel,
        handleAfterOpen,
        handleAfterClose,
        showCloseButton,
        closeTimeoutMS,
        shouldCloseOnOverlayClick,
        shouldCloseOnEsc,
        shouldReturnFocusAfterClose,
        shouldFocusAfterRender,
        modalIsOpen,
        closeModal,
        customWrapperClass = '',
    } = props;

    return (
        <div className="modal-wrapper">
            <ReactModal
                isOpen={
                    modalIsOpen
                    /* Boolean describing if the modal should be shown or not. */
                }
                onAfterOpen={
                    handleAfterOpen
                    /* Function that will be run after the modal has opened. */
                }
                onAfterClose={
                    handleAfterClose
                    /* Function that will be run after the modal has closed. */
                }
                onRequestClose={
                    closeModal
                    /* Function that will be run when the modal is requested
                 to be closed (either by clicking on overlay or pressing ESC).
                 Note: It is not called if isOpen is changed by other means. */
                }
                closeTimeoutMS={
                    closeTimeoutMS
                    /* Number indicating the milliseconds to wait before closing
                 the modal. */
                }
                style={
                    customStyles
                    /* Object indicating styles to be used for the modal.
                 It has two keys, `overlay` and `content`.
                 See the `Styles` section for more details. */
                    /* Object indicating styles to be used for the modal.
                 It has two keys, `overlay` and `content`.
                See the `Styles` section for more details. */
                }
                contentLabel={
                    contentLabel
                    /* String indicating how the content container should be announced
                 to screenreaders */
                }
                portalClassName={
                    `modal-portal ${customWrapperClass}`
                    /* String className to be applied to the portal.
                 See the `Styles` section for more details. */
                }
                overlayClassName={
                    'modal-overlay'
                    /* String className to be applied to the overlay.
                 See the `Styles` section for more details. */
                }
                id={
                    modalId
                    /* String id to be applied to the content div. */
                }
                className={
                    'modal-content'
                    /* String className to be applied to the modal content.
                 See the `Styles` section for more details. */
                }
                bodyOpenClassName={
                    'modalBody--open'
                    /* String className to be applied to the document.body
                 (must be a constant string).
                 This attribute when set as `null` doesn't add any class
                 to document.body.
                 See the `Styles` section for more details. */
                }
                htmlOpenClassName={
                    'modalHtml--open'
                    /* String className to be applied to the document.html
                 (must be a constant string).
                 This attribute is `null` by default.
                 See the `Styles` section for more details. */
                }
                ariaHideApp={
                    true
                    /* Boolean indicating if the appElement should be hidden */
                }
                shouldFocusAfterRender={
                    shouldFocusAfterRender
                    /* Boolean indicating if the modal should be focused after render. */
                }
                shouldCloseOnOverlayClick={
                    shouldCloseOnOverlayClick
                    /* Boolean indicating if the overlay should close the modal */
                }
                shouldCloseOnEsc={
                    shouldCloseOnEsc
                    /* Boolean indicating if pressing the esc key should close the modal
                 Note: By disabling the esc key from closing the modal
                 you may introduce an accessibility issue. */
                }
                shouldReturnFocusAfterClose={
                    shouldReturnFocusAfterClose
                    /* Boolean indicating if the modal should restore focus to the element
                 that had focus prior to its display. */
                }
                role={
                    'dialog'
                    /* String indicating the role of the modal, allowing the 'dialog' role
                 to be applied if desired.
                 This attribute is `dialog` by default. */
                }
                parentSelector={
                    () => document.querySelector('#modal-root')
                    /* Function that will be called to get the parent element
                 that the modal will be attached to. */
                }
                aria={
                    {
                        describedby: ariaDescription,
                        labelledby: ariaLabel,
                    }
                    /* Additional aria attributes (optional). */
                }
                data={
                    { background: '#ff' }
                    /* Additional data attributes (optional). */
                }
                overlayRef={
                    setOverlayRef
                    /* Overlay ref callback. */
                }
                contentRef={
                    setContentRef
                    /* Content ref callback. */
                }
            >
                {showCloseButton ? (
                    <button
                        type="button"
                        className="closeModal"
                        onClick={closeModal}
                    />
                ) : null}
                {children}
            </ReactModal>
        </div>
    );
};

Modal.propTypes = {
    ariaDescription: PropTypes.string,
    ariaLabel: PropTypes.string,
    children: PropTypes.node.isRequired,
    closeTimeoutMS: PropTypes.number,
    contentLabel: PropTypes.string,
    handleAfterClose: PropTypes.func,
    handleAfterOpen: PropTypes.func,
    modalButton: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    modalId: PropTypes.string,
    setContentRef: PropTypes.func,
    setOverlayRef: PropTypes.func,
    shouldCloseOnEsc: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    shouldFocusAfterRender: PropTypes.bool,
    shouldReturnFocusAfterClose: PropTypes.bool,
    modalIsOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    primaryButtonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    showCloseButton: PropTypes.bool,
    showActions: PropTypes.bool,
    onSuccessModal: PropTypes.func,
    customWrapperClass: PropTypes.string,
};

Modal.defaultProps = {
    closeTimeoutMS: 0,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldFocusAfterRender: true,
    shouldReturnFocusAfterClose: true,
};

export default Modal;
